import { jsx as _jsx } from "react/jsx-runtime";
import { ComponentSync, LL_H_C } from '@nu-art/thunderstorm-frontend/index';
import './Component_ManagerSubHeader.scss';
export class Component_ManagerSubHeader extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        return { isInEditMode: nextProps.isInEditMode, buttons: nextProps.buttons };
    }
    render() {
        return _jsx(LL_H_C, { className: 'manager-subheader match_width', children: this.state.buttons });
    }
}
//# sourceMappingURL=Component_ManagerSubHeader.js.map